import React, { useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

export default function LoggedOutSplash() {
    useEffect(() => {
        const t = setTimeout(() => {
            window.location.replace('/'); // nach kurzer Zeit zur Startseite
        }, 1500);
        return () => clearTimeout(t);
    }, []);

    return (
        <Box sx={{
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1.5,
            p: 2,
        }}>
            <CircularProgress />
            <Typography variant="h6">You were logged out.</Typography>
            <Typography variant="body2">Redirecting to Homepage …</Typography>
        </Box>
    );
}
